import React, { useCallback, useMemo } from "react";
import { getDevicesAsDropdownList } from "../../../utils/deviceUtils";
import { PcpDropdown, PcpDropdownOption } from "../../BaseComponents/PcpDropdown";
import { AudioDeviceInfo, VideoDeviceInfo } from "@azure/communication-calling";
import { OptionOnSelectData, SelectionEvents } from "@fluentui/react-components";


const dropdownStyles = { width: '100%', minHeight: '45px' };


interface ConfigurationPageDeviceDropdownProps {
    defaultPlaceHolder: string;
    noDevicesLabel: string;
    devices: AudioDeviceInfo[]|VideoDeviceInfo[];
    selectedDevice?: AudioDeviceInfo|VideoDeviceInfo;
    /** Default device if no device is selected */
    defaultDevice?: AudioDeviceInfo|VideoDeviceInfo;
    deviceAccessGranted?: boolean;
    deviceAccessDeniedLabel?: string;
    onSelectDevice: (deviceId: string) => void;
    ariaLabelledby?: string;
}

/**
 * Base component for selecting a AudioDevice or VideoDevice.
 *
 * @param props
 * @constructor
 */
export const ConfigurationPageDeviceDropdown = (props: ConfigurationPageDeviceDropdownProps): JSX.Element => {
    const {
        defaultDevice,
        selectedDevice,
        devices,
        defaultPlaceHolder,
        deviceAccessGranted,
        deviceAccessDeniedLabel,
        noDevicesLabel,
        onSelectDevice,
    } = props;

    const hasDevices = useMemo(
        () => devices.length > 0,
        [devices]
    );

    const defaultSpeakerId = useMemo(
        () => defaultDevice?.id,
        [defaultDevice]
    );
    const defaultSpeakerName = useMemo(
        () => defaultDevice?.name,
        [defaultDevice]
    );

    const onOptionSelect = useCallback((event: SelectionEvents, data: OptionOnSelectData) => {
        if (data.optionValue) {
            onSelectDevice(data.optionValue);
        }
    }, [onSelectDevice]);

    return (
        <PcpDropdown
            value={props.selectedDevice?.name}
            aria-labelledby={props.ariaLabelledby}
            placeholder={hasDevices ? defaultPlaceHolder : noDevicesLabel}
            disabled={devices.length === 0}
            defaultValue={selectedDevice ? selectedDevice.name : defaultSpeakerName}
            defaultSelectedOptions={props.selectedDevice ? [props.selectedDevice.id] : defaultSpeakerId ? [defaultSpeakerId] : []}
            onOptionSelect={onOptionSelect}
            aria-errormessage={
                deviceAccessGranted === undefined || deviceAccessGranted
                    ? undefined
                    : deviceAccessDeniedLabel
            }
            style={dropdownStyles}
        >
            {(deviceAccessGranted ? getDevicesAsDropdownList(props.devices) : [{ key: 'deniedOrUnknown', text: '' }]).map((option) => (
                <PcpDropdownOption
                    key={option.key} text={option.text} value={option.key as string} >
                    <span>{option.text}</span>
                </PcpDropdownOption>
            ))}
        </PcpDropdown>
    );
};
